import { ca } from '@cian/analytics';

export function trackSellersCarouselView(offers: Array<{ id: number; position: number }>, agentId: number): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show',
    label: 'media_agent_banner_carousel_view',
    products: offers.map(({ id, position }) => ({
      id,
      offerType: 'offer',
      position: position + 1,
    })),
    page: {
      extra: {
        agentId,
      },
    },
  });
}
